import { environmentBase } from './environment.base';

export const environment = {
  ...environmentBase,
  production: false,
  apiBaseUrl: 'https://uatnextupapi.octavehi.com/',
  timeout: 30000,
  debug: false,
  features: {
    ...environmentBase.features,
    enableAnalytics: true,
    enableLogging: true,
    enableCache: true
  },
  storage: {
    s3: {
      mediaBucketName: 'nextup-uatappmedia',
    },
    prefix: {
      attachment: 'attachment/',
    }
  }
};